var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Wrapper, ChatBubbleContentWrapper, AlignmentDiv } from './index.style';
var ChatContext = React.createContext({ direction: 'left', hasTail: false });
var ChatBubble = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'left' : _b, _c = _a.hasTail, hasTail = _c === void 0 ? true : _c, children = _a.children, props = __rest(_a, ["direction", "hasTail", "children"]);
    return (React.createElement(ChatContext.Provider, { value: { direction: direction, hasTail: hasTail } },
        React.createElement(Wrapper, __assign({ direction: direction }, props, { "data-testid": "chat-bubble" }),
            React.createElement(AlignmentDiv, { direction: direction }, children))));
};
var Content = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = React.useContext(ChatContext), direction = _b.direction, hasTail = _b.hasTail;
    return (React.createElement(ChatBubbleContentWrapper, __assign({ direction: direction, hasTail: hasTail, "data-testid": "chat-bubble-content" }, props), children));
};
ChatBubble.Content = Content;
var Footer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement("span", __assign({}, props), children));
};
ChatBubble.Footer = Footer;
export default ChatBubble;
export * from './types';
//# sourceMappingURL=index.js.map